import {
  AspectRatios,
  AspectRatioBox,
  Card,
  CardContent,
  CardTitle,
  CardDescription,
  BasePropsWithChildren,
  CardHeader,
} from "@greeter/matter";
import { doNothing, classNames } from "@greeter/util";
import { IonIcon } from "@ionic/react";
import { ellipsisHorizontal } from "ionicons/icons";
import React from "react";

import css from "./EditCard.module.scss";

const toCss = (ratio: AspectRatios) => {
  return ratio.split(":").join("/");
};

const CardCover: React.FC<{ ratio: AspectRatios; imageUrl: string }> = ({
  ratio,
  imageUrl,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundSize: "cover",
        backgroundImage: `url(${imageUrl})`,
        backgroundPosition: "center",
        opacity: "0.6",
        aspectRatio: toCss(ratio),
      }}
    />
  );
};

const EditButton: React.FC<{ onClick: () => void }> = () => {
  return (
    <div className={css.EditButton}>
      <IonIcon icon={ellipsisHorizontal} />
    </div>
  );
};

export type EditCardProps = BasePropsWithChildren & {
  title: string;
  subTitle: string;
  ratio?: AspectRatios;
  imageUrl?: string;
  onEdit?: () => void;
};

export const EditCard: React.FC<EditCardProps> = ({
  title,
  subTitle,
  ratio = "4:3",
  onEdit = doNothing,
  imageUrl = "",
  children,
  className,
  style,
  ...props
}) => {
  return (
    <Card
      onClick={onEdit}
      style={style}
      {...classNames(css.EditCard, className)}
      {...props}
    >
      <CardHeader style={{ position: "relative" }}>
        <CardCover ratio={ratio} imageUrl={imageUrl} />
        <EditButton onClick={onEdit} />
      </CardHeader>
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{subTitle ? subTitle : "Inkl. bord"}</CardDescription>
        {children}
      </CardContent>
    </Card>
  );
};
